<label class="switch">
    <input type="checkbox" id="togBtn" [checked]="checked" [disabled]="readonly">
    <div class="toggle round" (click)="toggle($event)" [ngStyle]="{'display':readonly? 'none' : 'block'}">
    </div>
    <span class="on" *ngIf='readonly'>{{label}}</span>
    <span class="off" *ngIf='readonly'>{{label}}</span>
</label>